
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface PuttingScoreButtonsProps {
  onScoreChange: (score: number) => void;
}

const PuttingScoreButtons: React.FC<PuttingScoreButtonsProps> = ({
  onScoreChange,
}) => {
  const { t } = useTranslation('common');

  return (
    <>
      <Button 
        onClick={() => onScoreChange(2)} 
        className="h-14 text-base font-medium bg-green-500 hover:bg-green-600 text-white border-0 w-full mb-2"
      >
        {t('puttingTraining.scoring.ballIn')} (2pts)
      </Button>
      <Button 
        onClick={() => onScoreChange(1)} 
        className="h-14 text-base font-medium bg-amber-500 hover:bg-amber-600 text-white border-0 w-full mb-2"
      >
        {t('puttingTraining.scoring.safeZone')} (1pt)
      </Button>
      <Button 
        onClick={() => onScoreChange(0)} 
        className="h-14 text-base font-medium bg-red-500 hover:bg-red-600 text-white border-0 w-full"
      >
        {t('puttingTraining.scoring.ballMissed')} (0pt)
      </Button>
    </>
  );
};

export default PuttingScoreButtons;
